// in mui spacing
export const LAYOUT_HEIGHT_LG = 9.9375;
export const LAYOUT_HEIGHT_SM = 9.375;
export const WITH_MOTORCYCLE = 'with_motorcycle';
export const WITHOUT_MOTORCYCLE = 'without_motorcycle';
export const BOTH = 'both';
export const RESERVATION_TYPS = {
  ANY_RESERVATION: 'any_reservations',
  WITH_MOTORCYCLE_RESERVATION_ONLY: 'with_motorcycle_reservations_only',
};
export const TOUR_TYPES = {
  GUIDED: 'guided',
  SELF_DRIVE: 'self_drive',
  GUIDED_OFFROAD: 'guided_offroad',
  ALL: 'all',
};
export const FOOTER_REF = 'footer';
export const NAVBAR_REF = 'navbar';
export const DROPDOWN_REF = 'dropdown-menu';
export const REF = {
  DEALS_LOCATION_REF: 'location_deals',
};
export const DEAL_TYPES = {
  DAILY_RATE: 'daily_rate',
  ONE_WAY_SPECIAL: 'one_way_special',
  BUY_ONE_DAY_GET_ONE: 'buy_one_day_get_one',
  BUY_X_DAYS_GET_Y_DAYS: 'buy_x_days_get_y_days',
  DISCOUNT_AMOUNT: 'discount_amount',
  TOUR: 'tour',
  DISCOUNT_PERCENT: 'discount_percent',
  PACKAGE_PRICE: 'package_price',
};
export const REFS = {
  MOTORCYCLE_TOUR_LANGING: 'motorcycle-tours-landing',
};

export const PLANS_TYPE = {
  GOLD: 'gold',
  SILVER: 'silver',
  BRONZE: 'bronze',
};
export const SLUGS_TYPES = {
  event: 'event',
  event_type: 'event_type',
  location: 'location',
  deal: 'deal',
  deal_type_category: 'deal_type_category',
  guided_tour: 'guided',
  guided_offroad_tour: 'guided_offroad',
  self_drive: 'self_drive',
  tour_type: 'tour_type',
  country: 'country',
  region: 'region',
  market: 'market',
  experience_page: 'experience_page',
  attraction: 'attraction',
  vehicle_model: 'vehicle_model',
  vehicle_make: 'vehicle_make',
  vehicle_type: 'vehicle_type',
  airport: 'airport',
  geography: 'geography',
  zipcode: 'zipcode',
};
